import React from 'react';
import PropTypes from 'prop-types';
import openSocket from 'socket.io-client';
import {toast,ToastContainer } from 'react-toastify';
//import queryString from 'query-string';
import isFunction  from 'lodash/isFunction';
import {EmitEvents} from '../../utils';
import DefaultContext  from "./Context";
import SysForms  from "./SysForms";
import Progress  from '../Progress';
import Alert  from '../Alert';
import Prompt  from '../Prompt';
import cloneDeep  from 'lodash/cloneDeep';
import {getCurrentPushEndpoint} from '../pushEndpoint';

function hashString(str) {
    let hash = 0x811c9dc5;

    for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);

        hash +=
            (hash << 1) +
            (hash << 4) +
            (hash << 7) +
            (hash << 8) +
            (hash << 24);
    }

    // Convert unsigned 32-bit to hex
    return (hash >>> 0).toString(16);
}

function getDeviceFingerprint() {
    /*const raw = [
        navigator.userAgent,
        navigator.language,
        navigator.platform,
        navigator.hardwareConcurrency,
        navigator.deviceMemory || '',
        screen.width,
        screen.height,
        screen.colorDepth,
        new Date().getTimezoneOffset(),
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        navigator.maxTouchPoints
    ].join('|');

    return hashString(raw);*/
    return crypto.randomUUID();
}


/**
 * PHA XÁC THỰC — nguồn sự thật DUY NHẤT để mọi component biết hệ thống đang ở bước nào.
 *
 * Trước đây component chỉ nhìn được `userInfo` nên không phân biệt nổi "chưa đăng nhập" với
 * "đang đăng nhập / đang chọn công ty". Hệ quả: bấm vào màn hình yêu cầu đăng nhập thì LockScreen
 * vẫn nằm chình ình phía sau hộp thoại đăng nhập và hộp thoại chọn công ty.
 *
 *   booting      mở app, đang khôi phục phiên từ token đã lưu
 *   anonymous    chưa đăng nhập (hoặc đang dùng user public)
 *   signing_in   form đăng nhập đang mở / đang xác thực
 *   choosing_app đã đăng nhập, đang chọn công ty
 *   loading      đã chọn công ty, đang tải menu/module
 *   needs_app    đã đăng nhập nhưng người dùng ĐÓNG hộp chọn công ty -> cần chọn lại
 *   ready        đủ user + công ty + menu, dùng bình thường
 */
export const AUTH_PHASE = {
  BOOTING: 'booting',
  ANONYMOUS: 'anonymous',
  SIGNING_IN: 'signing_in',
  CHOOSING_APP: 'choosing_app',
  LOADING: 'loading',
  NEEDS_APP: 'needs_app',
  READY: 'ready',
};
// Các pha "đang bận": UI nên hiện trạng thái chờ, TUYỆT ĐỐI không hiện màn yêu cầu đăng nhập.
const BUSY_PHASES = [AUTH_PHASE.BOOTING, AUTH_PHASE.SIGNING_IN, AUTH_PHASE.CHOOSING_APP, AUTH_PHASE.LOADING];
/** Lỗi khi người dùng chủ động đóng hộp thoại — không phải lỗi hệ thống, không cần báo đỏ. */
const CANCELLED = (what) => Object.assign(new Error(what), { code: 'CANCELLED', cancelled: true });

let socket;
class Provider extends React.PureComponent{
  constructor(props){
    super(props);
    this.initSocket = this.initSocket.bind(this);
    this.registerSocketEvents = this.registerSocketEvents.bind(this);
    let config = (this.props.config||{});
    this.state={
      load:0,
      // Pha xác thực + cờ bận, đưa thẳng vào context để component (AppContainer, LockScreen...)
      // biết đang ở bước nào mà hiển thị cho đúng.
      authPhase:AUTH_PHASE.BOOTING,
      authBusy:true,
      userInfo:null,
      appInfo:null,
      defaultAppInfo:null,
      modules:undefined,
      config,
      home_url:config.home_url,
      queryParams:config.queryParams||{},
      menu:[],
      apis:(this.props.apis||{}),
      getToken:this.getToken.bind(this),
      aboutus:this.aboutus.bind(this),
      signin:this.signin.bind(this),
      showUnlockRequired:this.showUnlockRequired.bind(this),
      verify:this.verify.bind(this),
      sign:this.sign.bind(this),
      signout:this.signout.bind(this),
      signup:this.signup.bind(this),
      right:this.right.bind(this),
      resetPassword:this.resetPassword.bind(this),
      resetPasswordByAdmin:this.resetPasswordByAdmin.bind(this),
      profile:this.profile.bind(this),
      setProgressStatus:this.setProgressStatus.bind(this),
      locationPicker:this.locationPicker.bind(this),
      objectPicker:this.objectPicker.bind(this),
      objectView:this.objectView.bind(this),
      makeCall:this.makeCall.bind(this),
      alert:this.alert.bind(this),
      prompt:this.prompt.bind(this),
      toast:this.toast.bind(this),
      chat:this.chat.bind(this),
      quickAdd:this.quickAdd.bind(this),
      quickEdit:this.quickEdit.bind(this),
      quickList:this.quickList.bind(this),
      quickReport:this.quickReport.bind(this),
      changeApp:this.changeApp.bind(this),
      setApp:this.setApp.bind(this),
      refresh:this.refresh.bind(this),
      registerEndpoint:this.registerEndpoint.bind(this),
      removeEndpoint:this.removeEndpoint.bind(this),
      getDeviceId:this.getOrCreateDeviceId.bind(this),
      // Năng lực máy chủ (gói mở rộng nào đã cài). Component dùng để ẩn/hiện tính năng thay vì đoán.
      features:{},
      /**
       * Máy chủ có tính năng này không? ai_agent | flow | marketing | usermodule
       * CHƯA BIẾT -> true, để không ẩn nhầm tính năng đang chạy tốt trên máy chủ đời cũ.
       */
      hasFeature:(name)=>{
        const apis = this.state.apis;
        if(apis && typeof apis.hasFeature === "function") return apis.hasFeature(name);
        return true;
      },
      /** Tên gói npm cần cài để có tính năng đó — để màn hình báo đúng tên gói cho quản trị viên. */
      featurePackage:(name)=>{
        const apis = this.state.apis;
        if(apis && typeof apis.featurePackage === "function") return apis.featurePackage(name);
        return name;
      },
      /** Đã hỏi xong máy chủ chưa (chưa xong thì UI nên chờ, đừng vội báo thiếu gói). */
      featuresLoaded:()=>{
        const apis = this.state.apis;
        if(apis && typeof apis.featuresLoaded === "function") return apis.featuresLoaded();
        return true;   // APIs đời cũ không có hàm này -> coi như xong, giữ nguyên hành vi cũ
      },
      /** Cho phép màn hình tự yêu cầu nạp năng lực máy chủ (APIs tự nhớ, chỉ gọi mạng 1 lần). */
      loadFeatures:this.loadFeatures.bind(this),
      AUTH_PHASE,
      // Đã đăng nhập thật (không tính user public)?
      isLoggedIn:()=>{
        const u = this.state.userInfo;
        return !!(u && u.email && u.email!=="public");
      },
      // Đã đăng nhập nhưng chưa có công ty -> UI nên mời chọn công ty, KHÔNG phải mời đăng nhập.
      needsApp:()=>{
        const u = this.state.userInfo;
        return !!(u && u.email && u.email!=="public") && !this.state.appInfo;
      },
      // Mở lại hộp chọn công ty (dùng cho nút "Chọn công ty" ở màn chờ).
      chooseAppAgain:()=>this.selectApp(this.state.userInfo),
    }
    // Promise của luồng đăng nhập đang chạy — dùng để GỘP mọi lời gọi signin() song song.
    this._authFlow = null;
  }

  /** Đổi pha xác thực (kèm state khác nếu cần). Cờ authBusy được tính sẵn cho consumer. */
  _setPhase(phase, extra = {}, cb){
    this.setState({
      authPhase: phase,
      authBusy: BUSY_PHASES.indexOf(phase) >= 0,
      ...extra,
    }, cb);
  }
  /** Pha tương ứng với dữ liệu hiện có: có công ty -> ready, có user -> needs_app, còn lại anonymous. */
  _restPhase(){
    const u = this.state.userInfo;
    if(u && u.email && u.email!=="public"){
      return this.state.appInfo ? AUTH_PHASE.READY : AUTH_PHASE.NEEDS_APP;
    }
    return AUTH_PHASE.ANONYMOUS;
  }

  componentWillUnmount(){
    if(this._unsubscribeAuth) { try{ this._unsubscribeAuth(); }catch(e){} }
    if(this._unsubscribeSessionExpired) { try{ this._unsubscribeSessionExpired(); }catch(e){} }
  }

  async componentDidMount(){
    const {config,queryParams} = this.state;

    // ── THEO DÕI TOKEN ĐƯỢC LÀM MỚI ────────────────────────────────────────────────────────────
    // Access token nay là JWT sống ~15 phút; APIs tự gọi /auth/refresh khi hết hạn và phát sự kiện.
    // Không cập nhật lại userInfo.token ở đây thì mọi request sau đó vẫn gắn token CŨ -> request nào
    // cũng phải đi đường vòng 401 -> refresh -> thử lại, tức gấp đôi số lượt gọi API.
    if(this.state.apis && typeof this.state.apis.onAuthChange === "function"){
      this._unsubscribeAuth = this.state.apis.onAuthChange(({access_token})=>{
        if(!access_token) return;
        this.setState((prev)=>{
          if(!prev.userInfo || prev.userInfo.token === access_token) return null;
          return { userInfo: {...prev.userInfo, token: access_token} };
        });
      });
    }

    // ── PHIÊN CHẾT -> ÉP VỀ MÀN ĐĂNG NHẬP ─────────────────────────────────────────────────────
    // Refresh thất bại, phiên bị thu hồi từ thiết bị khác, tài khoản bị khoá... đều không cứu được.
    // Nếu cứ để nguyên giao diện thì mọi thao tác tiếp theo chỉ nhận 401 và người dùng không hiểu
    // vì sao — nên dọn state rồi bật thẳng form đăng nhập. APIs chỉ phát sự kiện này ĐÚNG MỘT LẦN.
    if(this.state.apis && typeof this.state.apis.onSessionExpired === "function"){
      this._unsubscribeSessionExpired = this.state.apis.onSessionExpired(({reason})=>{
        this.handleSessionExpired(reason);
      });
    }

    config.PAGE_CONFIGS = config.PAGE_CONFIGS ||[];
    config.getPageConfig = (code) => {
      return config.PAGE_CONFIGS?.find(page => page.code === code) || null;
    };
    config.getReportConfig = (code) => {
      return config.REPORT_CONFIGS?.find(report => report.code === code) || null;
    };

    //get user infomation
    let token = (queryParams.access_token||"").replaceAll("/","");
    if(!token){
      token = localStorage.getItem("token");
    }else{
      localStorage.setItem("token",token);
    }
    //Kiểm tra token
    let userInfo;
    if(token){
      try{
        userInfo = await this.state.apis.asyncGetUserInfoByToken(token);
      }catch(e){
        //token không hợp lệ. Xoá token này khỏi máy của user
        localStorage.setItem("token","");
        token ="";
      }
    }
    // Hỏi máy chủ xem có những gói mở rộng nào (AI agent, flow, marketing...) để UI ẩn/hiện cho đúng.
    // Chạy nền: không chặn khởi động, có kết quả thì setState để component vẽ lại.
    this.loadFeatures(token || config.public_token);
    //
    if(config.default_id_app && config.public_token){
      try{
        let defaultAppInfo = await this.state.apis.asyncGetAppInfo(config.public_token,config.default_id_app);
        this.setState({defaultAppInfo})
      }catch(e){
        this.alert(e.message || e.error || e);
        this._setPhase(AUTH_PHASE.ANONYMOUS,{load:2})
        return;
      }
    }
    
    //tự động đăng nhập với user public nếu client là for_agent
    if(!token && config.public_token && config.login_with_public_user && queryParams.for_agent){
      token = config.public_token;
    }
    //console.log("auto login",{token,id_app:config.id_app});
    if(token && config.id_app){
      try{
        if(!userInfo) userInfo = await this.state.apis.asyncGetUserInfoByToken(token);
        userInfo.token = token;
        let appInfo = await this.state.apis.asyncGetAppInfo(token,config.id_app);
        config.system_code = appInfo.menu_code ||  config.system_code;
        let {modules,menu} = await this.state.apis.asyncGetModules(userInfo,null,config.id_app,(log)=>{
          this.setProgressStatus(true,null,log);
        });
        this.setProgressStatus(false);
        //console.log("auto login success",{appInfo,userInfo});
        if(userInfo.email=="public"){
          this.publicUserInfo = userInfo;
          this.publicAppInfo = appInfo;
          this.publicMenu = menu;
          this.publicModules = modules;
        }
        // Khôi phục phiên xong: vào thẳng pha READY (có user + công ty + menu).
        this._setPhase(AUTH_PHASE.READY,{load:2,userInfo,appInfo,menu,modules},async ()=>{
          //socket
          this.initSocket(userInfo,appInfo);
          //register endpoint
          this.registerEndpoint(userInfo);
        });
      }catch(e){
        console.error("[auto login]",e);
        localStorage.setItem("token","");
        if(e.code==-1){
          this.showUnlockRequired();
        }else{
          this.alert(e.message || e.error || e);
        }
        this._setPhase(AUTH_PHASE.ANONYMOUS,{load:2});
      }
    }else{
      // Không có token (hoặc chưa chọn công ty): boot xong ở trạng thái phù hợp với dữ liệu đang có.
      // Nếu token còn hạn nhưng chưa có id_app -> pha NEEDS_APP để UI mời CHỌN CÔNG TY, không phải
      // mời đăng nhập lại (đây chính là chỗ trước đây LockScreen hiện sai).
      const phase = (token && userInfo && userInfo.email!=="public") ? AUTH_PHASE.NEEDS_APP : AUTH_PHASE.ANONYMOUS;
      this._setPhase(phase,{load:2, userInfo: (token && userInfo) ? {...userInfo, token} : this.state.userInfo});
      //register endpoint
      this.registerEndpoint();
    }
  }
  /**
   * Lấy hoặc tạo một mã định danh thiết bị (deviceId) duy nhất.
   * @returns {string} - Device ID.
   */
  getOrCreateDeviceId(){
      let deviceId = localStorage.getItem('my_device_id');
      if (!deviceId) {
          deviceId = getDeviceFingerprint()
          localStorage.setItem('my_device_id', deviceId);
      }
      return deviceId;
  };
  refresh(){
    this.setState({load:this.state.load+1});
  }
  getToken(){
    if(this.state.userInfo) return this.state.userInfo.token;
    return this.state.config.public_token
  }
  initSocket(user,appInfo={}){
    const {config} = this.state;
    const _this = this;
    socket = EmitEvents.socket.socket;
    if(socket){
      try{
        socket.close();
      }catch(e){console.error(e.message)}
    }
    if(!user) return;
    //send userInfo to webview, cai nay co the khong an toan
    setTimeout(()=>{
      let postMessage = window.postMessage;
      if(postMessage){
        console.log("send token to webview");
        postMessage(JSON.stringify( {
          token: user.token,
          email: user.email,
          id_app:appInfo._id
        }));
      }
      
    },1000)
    //
    console.log("socket connecting")
    EmitEvents.socket.socket = socket = openSocket(config.server_url,{
      transports: ['websocket'], // Ép dùng websocket ngay từ đầu
      upgrade: false
    });

    socket.on('connect', function() {
      console.log("socket Connected")
      socket.emit("login", {
        token: user.token,
        email: user.email
      });
    });

    
    socket.io.on('reconnect', function() {
      console.log("socket reconnected")
      socket.emit("login", {
        token: user.token,
        email: user.email
      });
    });
    socket.io.on('reconnect_error', function() {
      console.error("socket reconnect error")
    });
    socket.io.on('reconnect_failed', function() {
      console.error("socket reconnect failed")
    });


    socket.on('disconnect', function() {
      console.error("socket disconnected")
    });
    
    socket.on('connect_error', function() {
      console.error("socket connect error")
    });
    socket.on('connect_timeout', (timeout) => {
      console.error("socket connect timeout",timeout)
    });
    socket.on('login', () => {
      console.log("Socket logined")
    });
    /*socket.emit("login", {
      token: user.token,
      email: user.email
    });*/
    socket.on('notify:count', function(data) {
      console.log("[socketIO]Số thông báo chưa đọc",data);
      EmitEvents.dispatch('notify:count',data);
    });
    socket.on('notify:new', function(data) {
      EmitEvents.dispatch('notify:new',data);
    });
    socket.on('message2:new', function(data) {
      //EmitEvents.dispatch('message2:new',data);
      if(data.id_link){
        EmitEvents.dispatch(`message2_group_${data.id_link}_changed`,data);
        EmitEvents.dispatch(`message2_group_all_changed`,data);
      }
    });

    socket.on('message2:update', function(data) {
      EmitEvents.dispatch(`message2_${data._id}:update`,data);
      if(data.id_link){
        EmitEvents.dispatch(`message2_group_${data.id_link}_changed`,data);
        EmitEvents.dispatch(`message2_group_all_changed`,data);
      }
    });

    socket.on('message2:delete', function(data) {
      EmitEvents.dispatch(`message2_${data._id}:delete`,data);
      if(data.id_link){
        EmitEvents.dispatch(`message2_group_${data.id_link}_changed`,data);
        EmitEvents.dispatch(`message2_group_all_changed`,data);
      }
    });

    socket.on('message2:read', function(data) {
      EmitEvents.dispatch(`message2_${data._id}:read`,data);
      if(data.id_link){
        EmitEvents.dispatch(`message2_group_${data.id_link}_changed`,data);
        EmitEvents.dispatch(`message2_group_all_changed`,data);
      }
    });

    /*socket.on('message2setting:new', function(data) {
      EmitEvents.dispatch('message2setting:new',data);
    });*/
    //checkin
    socket.on('checkin:new', function(data) {
      //EmitEvents.dispatch('checkin:new',data);
      _this.sysForms.checkin(data);
    });
    //calllog
    socket.on('calllog:new', function(data) {
      //console.log("calllog",data);
      //EmitEvents.dispatch('calllog:new',data);
      toast.info(`${_this.state.apis.getLabel("Đang gọi")}: ${data.data.ten_kh||"Unknown"} - ${data.data.phone}...`,{hideProgressBar:true,autoClose: 10000,onClick:()=>{
        if(data.data.id_kh){
          EmitEvents.dispatch('open.page',"/view/customer/" + data.data.id_kh);
        }else{
          _this.quickAdd("customer",{trang_thai:"0",dien_thoai:data.data.phone,ma_kh:data.data.phone},(rs)=>{
            EmitEvents.dispatch('open.page',"/view/customer/" + rs._id);
          })
        }
      }})
    });
    //task event
    socket.on('task:update', function(data) {
      //console.log("event task:update",data)
      //EmitEvents.dispatch('task:update',data);
      EmitEvents.dispatch('task_changed',data);
    });
    socket.on('task:new', function(data) {
      toast.info(`${_this.state.apis.getLabel("Công việc mới")}: ${data.title || data.body || ""}`,{hideProgressBar:true,autoClose: 3000,onClick:()=>{
        EmitEvents.dispatch('open.page',"/task/" + data._id);
      }})
      //EmitEvents.dispatch('task:new',data);
      EmitEvents.dispatch('task_changed',data);
    });
    socket.on('task:delete', function(data) {
      //console.log("event task:new",data)
      //EmitEvents.dispatch('task:delete',data);
      EmitEvents.dispatch('task_changed',data);
    });
    socket.on('allevents', function(data) {
      EmitEvents.dispatch(data.event,data.msg);
    });

    this.registerSocketEvents(socket,user);
    if(this.props.registerSocketEvents){
      this.props.registerSocketEvents(socket,this);
    }
  }
  // eslint-disable-next-line no-unused-vars
  registerSocketEvents(socket,user){
    //pbl event
    socket.on('pbl:payment', function(data) {
      //console.log("event pbl:payment",data)
      EmitEvents.dispatch('pbl:payment',data);
    });
    socket.on('pbl:update', function(data) {
      //console.log("event pbl:update",data)
      EmitEvents.dispatch('pbl:update',data);
    });
    socket.on('pbl:new', function(data) {
      //console.log("event pbl:new",data)
      EmitEvents.dispatch('pbl:new',data);
    });
    socket.on('pbl:delete', function(data) {
      //console.log("event pbl:new",data)
      EmitEvents.dispatch('pbl:delete',data);
    });
    
  }
  /**
   * Xoá đăng ký nhận thông báo đẩy.
   * `ep` truyền TƯỜNG MINH (chuỗi JSON của PushSubscription). Không truyền thì rơi về biến
   * toàn cục `endpoint` — bản gốc của ứng dụng di động/RN vẫn gán vào biến này.
   */
  async removeEndpoint(user,ep){
    return new Promise((res,rej)=> this.state.apis.removeEndpoint(user,(e)=>{
      if(e) return rej(e);
      res();
    },ep));
  }
  /**
   * Đăng ký endpoint nhận thông báo đẩy lên máy chủ.
   *
   * ⚠️ VÌ SAO TỪNG "LÚC ĐƯỢC LÚC KHÔNG": hàm này CHỈ đọc biến toàn cục `endpoint`
   * (khai `var endpoint` trong public/<brand>/configs.js). Hook usePushNotifications gọi
   * registerEndpoint(userInfo, endpoint) nhưng tham số thứ hai bị BỎ QUA, còn biến toàn cục
   * lúc đó có thể chưa được gán (mới tải trang, service worker chưa sẵn sàng) -> `if(!endpoint)
   * return` lặng lẽ thoát: bật xong vẫn không nhận được gì và không có lỗi nào hiện ra.
   * Nay nhận `ep` tường minh và chặn luôn các giá trị rác ("null"/"undefined") mà bản cũ
   * từng ghi lên máy chủ.
   */
  async registerEndpoint(user,ep){
    const {config} = this.state;
    // eslint-disable-next-line no-undef
    let endpointStr = ep || (typeof window!=="undefined" ? window.endpoint : (typeof endpoint!=="undefined" ? endpoint : null));
    // Không ai truyền và biến toàn cục cũng rỗng -> HỎI THẲNG service worker.
    // Trước đây hàm này im lặng thoát trong đúng tình huống hay gặp nhất: đổi công ty mà chưa
    // từng mở màn hình Thông báo (chỉ màn hình đó mới đặt biến toàn cục `endpoint`).
    if(!endpointStr || endpointStr==="null" || endpointStr==="undefined"){
      endpointStr = await getCurrentPushEndpoint();
    }
    if(!endpointStr || endpointStr==="null" || endpointStr==="undefined") return;
    //console.log("register endpoint for user",user?user.email:'public',"...");
    let url = `${config.server_url}/api/register-endpoint?access_token=${(user?user.token:config.public_token)}&ep=${encodeURIComponent(endpointStr)}`;
    // PHẠM VI CỦA ĐĂNG KÝ:
    //  - Ứng dụng ĐA CÔNG TY (id_app_dynamic): KHÔNG gắn id_app. Một đăng ký duy nhất, lập lúc
    //    đăng nhập, dùng cho tất cả các công ty — đổi công ty không phải làm gì thêm. (Gắn id_app
    //    ở đây đồng nghĩa với việc mọi đường đổi công ty đều phải nhớ đăng ký lại; sót một đường
    //    là mất thông báo mà không ai biết.)
    //  - Ứng dụng GẮN CỨNG một công ty: gắn đúng config.id_app để thông báo không lọt sang nơi khác.
    if(!config.id_app_dynamic && config.id_app){
      url = url + "&id_app=" + config.id_app;
    }
    return this.state.apis.asyncGet(url);
  }
  async delay(s){
    return new Promise((resolve)=>{
      setTimeout(function () {
        resolve(true)
      }, s);
    })
  }
  async setApp(userInfo,appInfo){
    if(userInfo.email!=this.state.userInfo?.email || appInfo._id!=this.state.appInfo?._id){
      const {config} = this.state;
      //console.log("setapp:get modules");
      config.system_code = appInfo.menu_code ||  config.system_code;
      let {modules,menu} = await this.state.apis.asyncGetModules(userInfo,null,appInfo._id);
      config.id_app = appInfo._id;
      localStorage.setItem("id_app",config.id_app);
      //console.log("setapp: set state",userInfo,appInfo,modules,menu);
      this._setPhase(AUTH_PHASE.READY,{
        load:this.state.load+1,
        userInfo,
        appInfo,
        menu,
        modules
      },()=>{
        if(this.sysForms && this.sysForms.appsFormRef) this.sysForms.appsFormRef.close();
        // Đa công ty: đăng ký là CHUNG, lập một lần lúc đăng nhập -> đổi công ty không cần làm gì.
        // Gắn cứng một công ty: config.id_app có thể vừa đổi -> đăng ký lại cho đúng phạm vi.
        if(!this.state.config.id_app_dynamic) this.registerEndpoint(userInfo);
      })
    }else{
      this._setPhase(AUTH_PHASE.READY,{
        load:this.state.load+1,
        userInfo,
        appInfo
      },()=>{
        if(this.sysForms && this.sysForms.appsFormRef) this.sysForms.appsFormRef.close();
      })
    }
  }
  async chooseApp(userInfo,changeApp=false){
    const {config} = this.state;
    
    if(config.id_app && !changeApp){
      try{
        this.setProgressStatus(true,null,"Get company infomartion...");
        let appInfo = await this.state.apis.asyncGetAppInfo(userInfo.token,config.id_app);
        this.setProgressStatus(true,null,"Get menu...");
        config.system_code = appInfo.menu_code ||  config.system_code;
        let {modules,menu} = await this.state.apis.asyncGetModules(userInfo,null,config.id_app,(log)=>{
          this.setProgressStatus(true,null,log);
        });

        this.setProgressStatus(false);
        return {appInfo,menu,modules}
      }catch(e){
        console.error("[provider] error get appInfo from config",e);
        if(e.code==-1){
          this.setProgressStatus(false);
          throw e
        }
      }
    }
    return new Promise((resolve,reject)=>{
      this.sysForms.chooseApp(userInfo,async (appInfo)=>{
        this._setPhase(AUTH_PHASE.LOADING);
        this.setProgressStatus(true,null,"Đang tải menu...");
        try{
          config.system_code = appInfo.menu_code ||  config.system_code;
          let {modules,menu} = await this.state.apis.asyncGetModules(userInfo,null,appInfo._id,(log)=>{
            this.setProgressStatus(true,null,log);
          });
          this.setProgressStatus(false);
          //
          config.id_app = appInfo._id;
          localStorage.setItem("id_app",config.id_app);
          resolve({appInfo,menu,modules});
        }catch(e){
          this.setProgressStatus(false);
          reject(e);
        }
      // Người dùng đóng hộp chọn công ty. Bản cũ KHÔNG có tham số này (SysForms.chooseApp chỉ nhận
      // 2 đối số) nên promise treo vĩnh viễn -> mọi `await signin()` đứng im mãi mãi.
      },()=>{
        this.setProgressStatus(false);
        reject(CANCELLED("Chưa chọn công ty"));
      });
    })
  }
  showUnlockRequired(callback){
    this.setProgressStatus(false);
    this.sysForms.unlockrequiredAlert(callback);
  }
  async changeApp(cb){
    if(!this.state.config.id_app_dynamic) return;
    const previous = { appInfo:this.state.appInfo, menu:this.state.menu, modules:this.state.modules };
    try{
      this._setPhase(AUTH_PHASE.CHOOSING_APP);
      let {appInfo,menu,modules} = await this.chooseApp(this.state.userInfo,true);
      // Xoá dữ liệu công ty cũ rồi mới gắn công ty mới, tránh trộn menu/module của 2 công ty.
      await this._setStateAsync({appInfo:null});
      this._setPhase(AUTH_PHASE.READY,{appInfo,menu,modules},()=>{
        // xem ghi chú ở setApp — đa công ty thì không phải đăng ký lại
        if(!this.state.config.id_app_dynamic) this.registerEndpoint(this.state.userInfo);
        if(typeof cb === "function") cb();
      });
    }catch(e){
      console.error(e);
      if(e && e.cancelled){
        // Đổi công ty giữa chừng rồi đóng hộp thoại -> GIỮ NGUYÊN công ty đang dùng,
        // không được để người dùng rơi vào màn hình trắng.
        this._setPhase(previous.appInfo ? AUTH_PHASE.READY : AUTH_PHASE.NEEDS_APP, previous);
        return;
      }
      if(e && e.code==-1){
        this._setPhase(previous.appInfo ? AUTH_PHASE.READY : AUTH_PHASE.NEEDS_APP, previous);
        return this.showUnlockRequired(()=>{
          this.changeApp(cb);
        });
      }
      this._setPhase(previous.appInfo ? AUTH_PHASE.READY : AUTH_PHASE.NEEDS_APP, previous);
      this.alert(e.error || e.message||e);
    }
  }
  async sign(title,user,data,onSuccess){
    this.sysForms.sign(title,user,data,onSuccess);
  }
  /**
   * Phiên đăng nhập đã chết (APIs.onSessionExpired): dọn sạch state rồi bật form đăng nhập.
   *
   * KHÔNG gọi signout() ở đây: signout() còn gọi API đăng xuất lên server bằng chính token đã chết
   * -> lại 401, lại nghi phiên chết, dễ thành vòng lặp. Ở đây chỉ dọn phía client.
   * @param {string} reason refresh_failed | session_revoked | token_used | invalid_token | account_disabled
   */
  handleSessionExpired(reason){
    const {config,userInfo} = this.state;
    if(this._handlingSessionExpired) return;         // nhiều request cùng chết -> chỉ xử lý 1 lần
    if(!userInfo || userInfo.email==="public") return; // khách vãng lai: không có gì để đăng xuất
    this._handlingSessionExpired = true;

    const messages = {
      session_revoked: "Phiên đăng nhập đã bị thu hồi. Vui lòng đăng nhập lại.",
      token_used: "Token này chỉ dùng được một lần. Vui lòng đăng nhập lại.",
      account_disabled: "Tài khoản của bạn đã bị khoá.",
    };
    const message = messages[reason] || "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.";
    console.warn("[provider] phiên chết:",reason);

    try{ localStorage.setItem("token",""); }catch(e){}
    try{ EmitEvents.dispatch('logout', userInfo.email); }catch(e){}
    this.setProgressStatus(false);

    // Đưa về trạng thái chưa đăng nhập (hoặc về user public nếu ứng dụng có chế độ khách)
    // TRƯỚC khi gọi signin — signin() thấy còn userInfo sẽ tưởng vẫn đăng nhập và không mở form.
    this._authFlow = null;   // luồng đăng nhập cũ (nếu có) không còn ý nghĩa
    this._setPhase(AUTH_PHASE.ANONYMOUS,{
      userInfo: this.publicUserInfo || null,
      appInfo: this.publicAppInfo || null,
      menu: this.publicMenu || [],
      modules: this.publicModule || null,
    }, ()=>{
      const showLogin = ()=>{
        this._handlingSessionExpired = false;
        // signin() trả Promise và REJECT khi người dùng đóng form -> phải catch, nếu không sẽ
        // thành unhandled rejection (React/trình duyệt log đỏ, một số môi trường coi là lỗi nặng).
        this.signin(()=>{}, {allow_cancel:false, only_signin:false})
          .catch((e)=>console.warn("[provider] người dùng chưa đăng nhập lại:", (e && e.message) || e));
      };
      // Báo cho người dùng biết vì sao bị đăng xuất rồi mới mở form (nếu có toast thì không chặn luồng).
      if(this.toast){ this.toast(message); showLogin(); }
      else if(this.alert){ this.alert(message, ()=>showLogin()); }
      else showLogin();
    });
  }

  /**
   * ĐĂNG NHẬP — điểm vào DUY NHẤT cho mọi component (AppContainer, LockScreen, nút Đăng nhập...).
   *
   * Ba vấn đề của bản cũ đã được xử lý ở đây:
   *   1. Nhiều component cùng gọi signin() -> mở nhiều form chồng nhau. Nay GỘP về một luồng
   *      (`this._authFlow`): ai gọi sau chỉ chờ kết quả của luồng đang chạy.
   *   2. Sau khi đăng nhập xong, bản cũ GÁN THẲNG `this.state.userInfo = userInfo` (không setState)
   *      rồi mới đi chọn công ty -> React KHÔNG re-render -> màn "Yêu cầu đăng nhập" vẫn nằm dưới
   *      hộp thoại chọn công ty. Nay cập nhật state ngay khi xác thực xong.
   *   3. Người dùng đóng hộp chọn công ty -> promise treo vĩnh viễn (mọi `await signin()` đứng im).
   *      Nay huỷ được và trả về pha NEEDS_APP để UI mời chọn lại.
   *
   * @param {Function} onSuccess (userInfo, appInfo, menu, modules)
   * @param {object}   options   { allow_cancel, only_signin }
   * @returns {Promise<object>}  userInfo
   */
  async signin(onSuccess,options={allow_cancel:true,only_signin:false}){
    // GỘP LỜI GỌI: luồng đang chạy thì dùng chung, không mở thêm form.
    if(this._authFlow){
      const userInfo = await this._authFlow;
      if(onSuccess) onSuccess(userInfo,this.state.appInfo,this.state.menu,this.state.modules);
      return userInfo;
    }
    this._authFlow = this._authenticate(options);
    let userInfo;
    try{
      userInfo = await this._authFlow;
    }catch(e){
      this._authFlow = null;
      this._setPhase(this._restPhase());
      if(e && e.cancelled) return this.state.userInfo;   // người dùng tự đóng -> không phải lỗi
      throw e;
    }
    this._authFlow = null;
    if(onSuccess) onSuccess(userInfo,this.state.appInfo,this.state.menu,this.state.modules);
    return userInfo;
  }

  /** Thân luồng đăng nhập (đã được signin() bọc chống gọi trùng). */
  async _authenticate(options={}){
    // (a) ĐÃ đăng nhập sẵn -> chỉ cần đảm bảo đã chọn công ty.
    const current = this.state.userInfo;
    if(current && current.email!=="public"){
      if(options.only_signin) return current;
      if(this.state.appInfo && this.state.menu) return current;
      await this.selectApp(current);
      return this.state.userInfo;
    }

    // (b) Có token đã lưu -> khôi phục phiên, KHÔNG bắt gõ lại mật khẩu.
    const stored = localStorage.getItem("token");
    if(stored && stored!==this.state.config.public_token){
      try{
        this._setPhase(AUTH_PHASE.SIGNING_IN);
        this.setProgressStatus(true,null,"Đang đăng nhập...");
        const userInfo = await this.state.apis.asyncGetUserInfoByToken(stored);
        userInfo.token = stored;
        this.setProgressStatus(false);
        if(options.only_signin){
          this._setPhase(AUTH_PHASE.NEEDS_APP,{userInfo});
          return userInfo;
        }
        // CẬP NHẬT STATE NGAY: UI thoát khỏi màn "Yêu cầu đăng nhập" trước khi mở hộp chọn công ty.
        await this._setStateAsync({userInfo, appInfo:null, menu:[], modules:null});
        await this.selectApp(userInfo);
        return this.state.userInfo;
      }catch(e){
        this.setProgressStatus(false);
        if(e && e.cancelled) throw e;
        if(e && e.code==-1) throw e;
        // Token hỏng -> xoá và rơi xuống nhánh (c) để hỏi mật khẩu.
        console.warn("[provider] token đã lưu không dùng được:", e && (e.message||e));
        localStorage.setItem("token","");
      }
    }

    // (c) Mở form đăng nhập.
    this._setPhase(AUTH_PHASE.SIGNING_IN);
    const userInfo = await new Promise((resolve,reject)=>{
      this.sysForms.signin(
        (u)=>resolve(u),
        (error)=>reject(error && error.cancelled ? error : CANCELLED("Đã huỷ đăng nhập")),
        options
      );
    });

    if(options.only_signin){
      this._setPhase(AUTH_PHASE.NEEDS_APP,{userInfo});
      return userInfo;
    }
    // Xác thực xong -> vào state NGAY (điểm mấu chốt: LockScreen biến mất tức thì).
    await this._setStateAsync({userInfo, appInfo:null, menu:[], modules:null});
    await this.selectApp(userInfo);
    this.registerEndpoint(this.state.userInfo);
    return this.state.userInfo;
  }

  /**
   * CHỌN CÔNG TY + tải menu/module, rồi đưa về pha READY.
   * Tách riêng để dùng lại cho: đăng nhập xong, đổi công ty, và nút "Chọn công ty" ở màn chờ.
   */
  async selectApp(userInfo){
    if(!userInfo) return null;
    this._setPhase(AUTH_PHASE.CHOOSING_APP);
    try{
      const {appInfo,menu,modules} = await this.chooseApp(userInfo);
      await new Promise((resolve)=>{
        this._setPhase(AUTH_PHASE.READY,{userInfo,appInfo,menu,modules},resolve);
      });
      this.initSocket(this.state.userInfo,appInfo);
      this.loadFeatures(this.state.userInfo && this.state.userInfo.token);
      // Chọn công ty xong là đã có đủ token + id_app: đăng ký ở đây phủ luôn đường đăng nhập
      // (với ứng dụng đa công ty thì đây chính là LẦN ĐĂNG KÝ DUY NHẤT cần thiết).
      this.registerEndpoint(this.state.userInfo);
      return appInfo;
    }catch(e){
      console.error(e);
      this.setProgressStatus(false);
      if(e && e.cancelled){
        // Đóng hộp chọn công ty: vẫn ĐANG ĐĂNG NHẬP, chỉ thiếu công ty.
        // Pha NEEDS_APP để UI mời chọn công ty thay vì mời đăng nhập lại.
        this._setPhase(AUTH_PHASE.NEEDS_APP);
        throw e;
      }
      if(e && e.code==-1){
        this._setPhase(AUTH_PHASE.NEEDS_APP);
        return this.showUnlockRequired(async ()=>{
          await this.signout();
          if(this.state.home_url!=window.location.href){
            window.location.href = this.state.home_url;
          }else{
            window.location.reload();
          }
        });
      }
      this._setPhase(AUTH_PHASE.NEEDS_APP);
      this.alert((e && (e.error || e.message)) || e);
      throw e;
    }
  }

  /**
   * Nạp danh sách tính năng máy chủ hỗ trợ. Gọi được nhiều lần — APIs tự nhớ kết quả, chỉ gọi mạng 1 lần.
   */
  async loadFeatures(token){
    const apis = this.state.apis;
    if(!apis || typeof apis.asyncGetFeatures !== "function") return null;
    try{
      const rs = await apis.asyncGetFeatures(token || this.getToken());
      const features = (rs && rs.features) || {};
      this.setState({features});
      return features;
    }catch(e){
      console.warn("[provider] không lấy được năng lực máy chủ:", e && e.message);
      return null;
    }
  }

  /** setState dạng Promise — để luồng đăng nhập chờ UI cập nhật xong mới đi tiếp. */
  _setStateAsync(next){
    return new Promise((resolve)=>this.setState(next,resolve));
  }

  async verify(options={}){
    return new Promise((resolve,reject)=>{
      this.sysForms.signinSms(async userInfo=>{
        resolve(userInfo);
      },(error)=>{
        reject(error);
      },options);
    })
  }
  async signup(data,onSuccess,onCancel){
    this.sysForms.signup(data,async userInfo=>{
      if(data.only_signup){
        if(onSuccess){
          onSuccess(userInfo);
        }
        return;
      }
      this.setState({userInfo,appInfo:null},async ()=>{
        try{
          let {appInfo,menu,modules} = await this.chooseApp(userInfo);
          this.setState({appInfo,menu,modules},()=>{
            this.initSocket(userInfo,appInfo);
            if(onSuccess){
              onSuccess(userInfo,appInfo,menu,modules);
            }
          })
        }catch(e){
          if(e.code==-1){
            this.showUnlockRequired(async ()=>{
              await this.signout();
              if(this.state.config?.home_url!=window.location.href){
                window.location.href = this.state.config?.home_url;
              }else{
                window.location.reload();
              }
            });
          }else{
            this.alert(e.error || e.message||e,null,"red");
          }
        }
      })
    },()=>{
      if(onCancel) onCancel();
    });
  }

  async right(user_group_id,user_group_name=""){
    this.sysForms.right(user_group_id,user_group_name)
  }
  async signout(){
    const {config,userInfo,queryParams} = this.state;
    return new Promise(async (resolve)=>{
      try{
        localStorage.setItem("token","");
        localStorage.setItem("id_app",queryParams.id_app || "");
        if(config.id_app_dynamic){
          config.id_app = queryParams.id_app || null;
          this._authFlow = null;
          this._setPhase(AUTH_PHASE.ANONYMOUS,{
            userInfo:null,
            appInfo:null,
            modules:null,
            menu:[]
          },async ()=>{
            try{
              //signout server
              if(userInfo) await this.state.apis.asyncLogoutAPI(userInfo);
              EmitEvents.dispatch('logout',userInfo.email);
              //signout facebook
              if(config.facebook_app_id){
                // eslint-disable-next-line no-undef
                FB.getLoginStatus(function(response) {
                  if (response.status === 'connected') {
                      // eslint-disable-next-line no-undef
                      FB.logout(function() {
                        console.log("facebook logout");
                      });
                  }
                });
              }
            }catch(e){
              console.error(e);
            }
            resolve()
            //
          })
        }else{
          if(config.public_token && config.login_with_public_user && queryParams.for_agent && !this.publicUserInfo){
            try{
              let token = config.public_token;
              this.publicUserInfo = await this.state.apis.asyncGetUserInfoByToken(token);
              this.publicUserInfo.token = token;

              if(!this.publicAppInfo) this.publicAppInfo = await this.state.apis.asyncGetAppInfo(token,config.id_app);
              if(!this.publicModule){
                config.system_code = this.publicAppInfo?.menu_code ||  config.system_code;
                let {modules,menu} = await this.state.apis.asyncGetModules(userInfo,null,config.id_app,(log)=>{
                  //this.setProgressStatus(true,null,log);
                });
                this.publicModule = modules;
                this.publicMenu = menu;
              }
            }catch(e){
              console.error("signout: restart public user",e);
            }
          }
          this._authFlow = null;
          this._setPhase(AUTH_PHASE.ANONYMOUS,{
            load:this.state.load+1,
            appInfo:this.publicAppInfo,
            userInfo:this.publicUserInfo,
            menu:this.publicMenu||[],
            modules:this.publicModule
          }, async ()=>{
            try{
              //signout server
              if(userInfo && userInfo.email!=="public"){
                await this.state.apis.asyncLogoutAPI(userInfo);
                EmitEvents.dispatch('logout',userInfo.email);
                //signout facebook
                if(config.facebook_app_id){
                  // eslint-disable-next-line no-undef
                  FB.getLoginStatus(function(response) {
                    if (response.status === 'connected') {
                        // eslint-disable-next-line no-undef
                        FB.logout(function() {
                          console.log("facebook logout");
                        });
                    }
                  });
                }
              }
            }catch(e){
              console.error(e);
            }
            resolve();
            //
          })
        }
      }catch(e){
        console.log("Can't logout this account",e.message);
        resolve();
      }
    })
    
  }
  async resetPassword(onSuccess){
    this.sysForms.resetPassword(userInfo=>{
      this.setState({
        userInfo:userInfo
      },()=>{
        if(onSuccess) onSuccess(userInfo);
      })
    });
  }
  async resetPasswordByAdmin(email,id_app,onSuccess){
    this.sysForms.resetPasswordByAdmin(email,id_app,(rs)=>{
      if(onSuccess) onSuccess(rs);
    });
  }
  async profile(onSuccess,options={tab:9}){
    this.sysForms.profile(userInfo=>{
      this.setState({
        userInfo
      },()=>{
        if(onSuccess) onSuccess(userInfo);
      })
    },options)
  }
  async aboutus(){
    this.sysForms.aboutus();
  }
  setProgressStatus(status,callback,title){
    if(this.progress) this.progress.running(status,callback,title);
  }
  alert(title,callback,color,options){
    this.setProgressStatus(false);
    if(this.alertRef){
      setTimeout(()=>{
        this.alertRef.show(title,callback,color,options);
      },10)
      
    }else{
      alert(title);
    }
  }
  prompt(title,default_value,callback,options){
    if(this.promptRef){
      if(options==undefined && !isFunction(callback)){
        options = callback;
        return new Promise(resolve=>{
          this.promptRef.show(title,default_value,(value)=>{
            resolve(value)
          },options);
        })
      }else{
        this.promptRef.show(title,default_value,callback,options);
      }
    }
  }
  toast(title,options={autoClose:1000}){
    toast.info(title,{hideProgressBar:true,autoClose: (options.autoClose || 1000),onClick:()=>{
      if(options.onClick) options.onClick()
    }})
  }
  chat(group,options){
    if(!group) return;
    this.sysForms.chat(group,options);
  }
  quickAdd(code,data,callback){
    if(!code) return;
    delete data.listinfo_code;
    this.sysForms.quickAdd(code,data,callback);
  }
  quickEdit(code,data,callback){
    if(!code || !data) return;
    this.sysForms.quickEdit(code,data,callback);
  }
  quickReport(code,condition={},title="Báo cáo"){
    if(!code) return;
    this.sysForms.quickReport(code,condition,title);
  }
  quickList(code,title,options={}){
    if(!code) return;
    options.props = options.props||{};
    options.props.pickItem = false;
    return this.objectPicker(code,title,options);
  }
  locationPicker(title,options={}){
    let _options ={...options};
    return new Promise((result)=>{
      _options.callback= (selected)=>{
        if(options.callback){
          options.callback(selected);
        }
        result(selected);
      }
      this.sysForms.locationPicker(title,_options);
    })
  }
  async objectPicker(code,title,options={}){
    if(!code) return;
    const {callback,onClose,...restOptions} = options;
    let _options = cloneDeep(restOptions);
    let rs = await (new Promise((resolve)=>{
      _options.callback= (item_selected)=>{
        //console.log("[Provider][objectPicker] xử lý callback trả về kết quả..")
        if(callback){
          callback(item_selected);
        }
        resolve(item_selected);
      }
      _options.onClose = (item_selected)=>{
        //console.log("[Provider][objectPicker] xử lý onClose..")
        if(onClose){
          onClose(item_selected);
        }
        resolve(item_selected);
      }
      this.sysForms.objectPicker(code,title,_options);
    }));
    //console.log("[provider] [objectPicker] kết quả",rs)
    return rs;
  }
  objectView(code,_id,options={}){
    if(!code || !_id) return;
    let _options ={...options};
    this.sysForms.objectView(code,_id,_options);
  }
  makeCall(phone){
    this.sysForms.makeCall(phone);
  }
  render(){
    const SystemForm = this.props.sysForms || SysForms;
    return (
      <DefaultContext.Provider  value={this.state}>
        <SystemForm ref={ref=>this.sysForms=ref}/>
        <Progress ref={ref=>this.progress=ref}/>
        <Alert ref={ref=>this.alertRef=ref}/>
        <Prompt ref={ref=>this.promptRef=ref}/>
        {this.state.load!=0 && this.props.children}
        <ToastContainer/>
      </DefaultContext.Provider>
    )
  }
}
Provider.propTypes={
  children: PropTypes.any,
  sysForms: PropTypes.any,
  config:PropTypes.object.isRequired,
  apis:PropTypes.object.isRequired,
  handleSocketEvents:PropTypes.func,
  registerSocketEvents:PropTypes.func,
}
export default Provider;
